module.exports = __webpack_public_path__ + "static/media/JAPAN-Waseda.05cc5a55.png";